/*健哥不在工位上 打开电脑 替换端口连接
CRM  http://192.168.1.86:8353/
CYL  http://192.168.1.86:8350/
TAG  http://192.168.1.86:8361/
*/


let serverHost = {
	"tag": "https://tag.ocn.com.cn",
	"user": "https://user.ocn.com.cn",
	// "user": "https://106.52.243.203",
	"cyl": "https://lian.ocn.com.cn",
	"crm": "https://crmapi.ocn.com.cn",
	"bigdata": "https://d.ocn.com.cn",
	"report": "https://bg.ocn.com.cn",
	"download": "http://download.chanyedanao.cn",
	"park": "https://parkapi.ocn.com.cn", 
	"common": "https://common.ocn.com.cn",
};
let localHost = {
	// "tag": "http://i9o1vfrc.shenzhuo.vip:30332",
	// "user": "http://m49128s358.51vip.biz:38423",
	// "cyl": "http://m49128s358.51vip.biz:53767",
	// "crm": "http://m49128s358.51vip.biz:56509",
	/*-----------------------------------------*/
	"tag": "http://192.168.1.86:8361",
	"cyl": "http://192.168.1.86:8350",
	// "cyl": "http://192.168.1.86:2247",
	"crm": "http://192.168.1.86:2521",
	// ------------------------------------------
	// "tag": "http://192.168.1.86:8361",
	
	// "crm": "http://192.168.1.86:8353",

	/*-----------------------------------------*/
	"park": "http://192.168.1.86:8380",
	"user": "http://192.168.1.86:8610",
	"bigdata": "http://192.168.1.86:8355",
	"report": "http://192.168.1.86:8351",
	"download": "http://192.168.1.86:8367",
	"common": "http://192.168.1.86:5118",
};


// let localHost = {
// 				"tag": "http://i9o1vfrc.shenzhuo.vip:30332",
// 				"user": "http://m49128s358.51vip.biz:38423",
// 				"cyl": "http://m49128s358.51vip.biz:53767",
// 				"crm": "http://m49128s358.51vip.biz:56509",
// };
let isLocal = false;
var hrefl = window.location.href.toLowerCase();

if (hrefl.indexOf(".com") > 0 || hrefl.indexOf(".cn") > 0) {
	isLocal = false;
}else {
	isLocal = true;
}

function getHost(system) {
	if (isLocal) {
		return localHost[system];
	}
	return serverHost[system];
}
window.getApiUrl = function (path, system, args) {
	let url = getHost(system) + path;
	let symbol = url.indexOf("?") > 0 ? "&" : "?";
	if (args) {
		for (let key in args) {
			if (args[key] != '' && args[key] != 0) {
				url += symbol + key + "=" + encodeURIComponent(args[key]);
				symbol = "&";
			}
		}
	}
	return url;
};

function getOrigin() {
	if (!window.location.origin) {
		return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	}

	return window.location.origin;
}

function getLoginUrl() { //登录
	// var path = getOrigin() + '/#/login';
	// var loginUrl = getHost('user') + '/user/login?refer=';
	// var refer = window.btoa(path);
	// console.log(loginUrl,refer);
	return "/#/user-login";
	// return loginUrl + refer;
}

function getLogoutUrl() { //登出
	// var path = getOrigin() + '/#/login';
	// var logoutUrl = getHost('user') + '/user/logout?refer=';
	// var refer = window.btoa(path);
	// return logoutUrl + refer;
	return "/#/user-login";
}

function getBigDataUrl(type) { //拿地信息库 投资项目库
	var url = '';
	if (type == 'macro' || type == 'invest' || type == 'land') {
		url = getHost('bigdata') + '/s/' + type + '/home/index?from=cydn';
	}
	return url;
}

function getReportUrl() { //研究报告
	var path = getHost('report') + '/r/ticket/index';
	var refer = window.btoa(path);
	// return path;
	return getHost('user') + '/user/login?refer=' + refer;
}

function getDownloadUrl(token, stockCode, city, companyName) { //企业报告下载
	var url = getHost('download');
	url += '/download/report?stockcode=' + stockCode + '&token=' + token + '&city=' + city + '&name=' + companyName +
		'&t=' + new Date().getTime();
	return url;
}
function getReportListUrl(id, second_Id) { //研究报告列表id跳转 
	if (!second_Id) { //有second_Id代表有二级分类
		var query = '/r/report/list?bc=' + id;
	} else {
		var query = '/r/report/list?bc=' + id + "__sc=" + second_Id;
	}
	var path = getHost('report') + '/r/ticket/index?backurl=' + query;
	var refer = window.btoa(path);
	console.log(path, refer);
	var url = getHost('user') + '/user/login?refer=' + refer;
	console.log(url);
	return url;
}
function getFreeReportUrl(id) { //免费报告id跳转 
	var query = 'http://free.ocn.com.cn/report/list?ec=' + id;
	return query;
}
var websiteList = [
	/*
	 downloadRptType 用于企业详情页下载报告传给后台的端口类型 0=招商，1=园区,2=治理,3=信贷,4=投资,5=研究;
	 Water 用于免费用户的水印图片标识
	 */
	{ name: "产业招商大脑", shortname: "产业招商大脑", type: 1, url: "zs.chanyedanao", keyword: '招商', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 0 },
	{ name: "产业治理大脑", shortname: "产业治理大脑", type: 2, url: "yj.chanyedanao", keyword: '投资', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 2 },
	{ name: "产业治理大脑", shortname: "产业治理大脑", type: 2, url: "www.chanyedanao", keyword: '投资', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 2 },
	{ name: "产业治理大脑", shortname: "产业治理大脑", type: 2, url: "//chanyedanao", keyword: '投资', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 2 },
	{ name: "园区招商大脑", shortname: "园区招商大脑", type: 3, url: "p.chanyedanao.cn", keyword: '招商', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 1 },
	{ name: "产业信贷大脑", shortname: "产业信贷大脑", type: 4, url: "cr.chanyedanao.cn", keyword: '信贷', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 3 },
	{ name: "产业投资大脑", shortname: "产业投资大脑", type: 5, url: "tz.chanyedanao.cn", keyword: '投资', keyword1: "投资", hxname: "投资画像", shortlistName: "投资标的短名单", mapname: "招商", downloadRptType: 4 },
	//****////
	{ name: "产业招商大脑", shortname: "产业招商大脑", type: 1, url: "zhaoshangdanao.com", keyword: '招商', keyword1: "招商", hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 0, selfControl: true,water:'zs' },
	{ name: "产业大脑-产业治理大脑", shortname: "产业治理大脑", type: 2, url: "chanyedanao.cn", keyword: '招商', keyword1: "投资", hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 2, selfControl: true,water:'watermark' },
	{ name: "园区招商大脑", shortname: "园区招商大脑", type: 3, url: "yuanqudanao.com", keyword: '招商', keyword1: "招商", hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 1, selfControl: true, water:'watermark'},
	{ name: "产业大脑-产业信贷大脑", shortname: "产业信贷大脑", type: 4, url: "xindaidanao.com", keyword: '信贷', keyword1: "市场", hxname: "信贷画像", shortlistName: "信贷精准客户短名单", mapname: "数字", downloadRptType: 3, selfControl: true, water:'watermark'},
	{ name: "产业投资大脑", shortname: "产业投资大脑", type: 5, url: "chanyetouzi.com", keyword: '投资', keyword1: "投资", hxname: "投资画像", shortlistName: "投资标的短名单", mapname: "数字", downloadRptType: 4, selfControl: true, water:'tz'},
	{ name: "产业研究大脑", shortname: "产业研究大脑", type: 6, url: "chanyeyanjiu.cn", keyword: '招商', keyword1: "招商", hxname: "企业画像", shortlistName: "精准企业短名单", mapname: "数字", downloadRptType: 5, selfControl: true,water:'yj' },
	{ name: "上海产业运算大数据平台", shortname: "产业运算平台", type: 7, url: "zhaoshangdanao.com.cn", keyword: '招商', keyword1: "招商", hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 0, selfControl: false,water:'zs' },
	{ name: "上海产业运算大数据平台", shortname: "产业运算平台", type: 7, url: "chanyezhaoshang.com", keyword: '招商', keyword1: "招商", hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 0, selfControl: false, water:'zs'},
	{ name: "产业招商大脑", shortname: "产业招商大脑", type: 8, url: "zs.chanyedanao.cn", keyword: '招商', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 0, selfControl: false, water:'zs'},
	{ name: "产业招商大脑", shortname: "产业招商大脑", type: 9, url: "sima.chanyedanao.cn", keyword: '招商', hxname: "招商画像", shortlistName: "精准招商短名单", mapname: "招商", downloadRptType: 0, selfControl: false,water:'zs' },
	{ name: "上市公司战略并购标的库", shortname: "优 标 库", type: 10, url: "ybk.chanyetouzi.com", keyword: '投资', keyword1: "投资", hxname: "投资画像", shortlistName: "投资标的短名单", mapname: "数字", downloadRptType: 4, selfControl: true, water:'tz'},
	{ name: "上市公司战略并购标的库", shortname: "优 标 库", type: 10, url: "youbiaoku.com", keyword: '投资', keyword1: "投资", hxname: "投资画像", shortlistName: "投资标的短名单", mapname: "数字", downloadRptType: 4, selfControl: true, water:'tz'},



];
// 1,7,8,9 都是招商版，1是中投正式，7是上海深中云，8是默认渠道用户，9是SIMA渠道用户 ，10是优标库
// 产业大脑-产业治理大脑，chanyedanao.cn
// 产业招商大脑，zhaoshangdanao.com
// 园区招商大脑，yuanqudanao.com
// 产业投资大脑，chanyetouzi.com
// 产业大脑-产业信贷大脑，xindaidanao.com
//产业研究大脑 chanyeyanjiu.cn
//优标库 ybk.chanyetouzi.com
// sima sima.chanyedanao.cn 

var testWebsiteUrl = "zs.chanyedanao";//修改链接地址就可以直接切换本地产业大脑版本
let ajaxapi = {
	'zsdn_version':2,
	'setZsdnVersion': function (type) {
		return this.zsdn_version = type;
	},
	'demonstrate': function () {
		var websiteHref = isLocal ? testWebsiteUrl : window.location.href.toLowerCase();
		// var websiteHref = testWebsiteUrl;

		return websiteHref.indexOf('ys.') > -1;
	},
	'getWebsiteType': function () {
		var websiteHref = isLocal ? testWebsiteUrl : window.location.href.toLowerCase();
		// var websiteHref = testWebsiteUrl;
		var curwebsit = [];
		for (var i = 0; i < websiteList.length; i++) {
			if (websiteHref.indexOf(websiteList[i].url) > -1) {
				curwebsit = websiteList[i];
			}
		}
		// console.log('当前端口',curwebsit);
		return curwebsit;
		// return websiteHref.indexOf("zs.chanyedanao.cn") > -1;
	},
	'iszsdn': function () {
		var websiteHref = window.location.href.toLowerCase();
		return websiteHref.indexOf("zs.chanyedanao.cn") > -1;
	},
	'free':{
		"wxpay": {
			"QRCode": function (args) {
				return getApiUrl('/api/free/v1/wxpay/QRCode', 'cyl', args);
			},
			"pay": function (args) {
				return getApiUrl('/api/free/v1/wxpay/pay', 'cyl', args);
			},
		},
		"order": {
			"module": function (args) {
				return getApiUrl('/api/free/v1/order/module', 'cyl', args);
			},
			"post": function (args) {
				return getApiUrl('/api/free/v1/order/post', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/free/v1/order/detail', 'cyl', args);
			},
		},
		"competitive": {
			"comprehensive": function (args) {
				return getApiUrl('/api/free/v1/competitive/comprehensive', 'cyl', args);
			},
			"scienceTech": function (args) {
				return getApiUrl('/api/free/v1/competitive/scienceTech', 'cyl', args);
			},
			"industry": function (args) {
				return getApiUrl('/api/free/v1/competitive/industry', 'cyl', args);
			},
			"localInvest": function (args) {
				return getApiUrl('/api/free/v1/competitive/localInvest', 'cyl', args);
			},
			"financing": function (args) {
				return getApiUrl('/api/free/v1/competitive/financing', 'cyl', args);
			},
			"externalInvest": function (args) {
				return getApiUrl('/api/free/v1/competitive/externalInvest', 'cyl', args);
			},
		},
		
	},
	'common': {
		'customized':{
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/customized/List', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/investapi/v1/customized/Detail', 'common', args);
			},
			"chatDetail": function (args) {
				return getApiUrl('/api/investapi/v1/customized/ChatDetail', 'common', args);
			},
		},
		"tencent": {
			"assistantList": function (args) {
				return getApiUrl('/api/aiapi/v1/tencent/AssistantList','common', args);
			},
			"assistantChat": function (args) {
				return getApiUrl('/api/aiapi/v1/tencent/AssistantChat','common', args);
			},
			"history": function (args) {
				return getApiUrl('/api/aiapi/v1/tencent/History','common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/aiapi/v1/tencent/Detail','common', args);
			},
			"rename": function (args) {
				return getApiUrl('/api/aiapi/v1/tencent/Rename','common', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/aiapi/v1/tencent/Delete','common', args);
			},
		},
		"deepseek": {
			"chat": function (args) {
				return getApiUrl('/api/aiapi/v1/deepseek/Chat','common', args);
			}
		},
		"analyse": {
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/analyse/List','common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/investapi/v1/analyse/Detail','common', args);
			},
			"chatDetail": function (args) {
				return getApiUrl('/api/investapi/v1/analyse/ChatDetail','common', args);
			}
		},
		"chart": {
			"upload": function (args) {
				return getApiUrl('/api/investapi/v1/chart/Upload', 'common', args);
			},
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/chart/List', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/investapi/v1/chart/Detail', 'common', args);
			},
			"setChartType": function (args) {
				return getApiUrl('/api/investapi/v1/chart/SetChartType', 'common', args);
			},
			"postData": function (args) {
				return getApiUrl('/api/investapi/v1/chart/PostData', 'common', args);
			},
			
		},
		"market": {
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/market/list', 'common', args);
			},
			"mergeList": function (args) {
				return getApiUrl('/api/investapi/v1/market/mergeList', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/investapi/v1/market/detail', 'common', args);
			},
			
		},
		"sms": {
			"isSmsLogin": function (args) {
				return getApiUrl('/api/investapi/v1/sms/isSmsLogin', 'common', args);
			},
			"send": function (args) {
				return getApiUrl('/api/investapi/v1/sms/send', 'common', args);
			},
		},
		"parameter": {
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/parameter/list', 'common', args);
			},
		},
		"policy": {
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/policy/list', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/investapi/v1/policy/detail', 'common', args);
			},
		},
		"invest": {
			"country": function (args) {
				return getApiUrl('/api/investapi/v1/invest/country', 'common', args);
			},
			"list": function (args) {
				return getApiUrl('/api/investapi/v1/invest/list', 'common', args);
			},
		},
		"enterprise": {
			"detail": function (args) {
				return getApiUrl('/api/investapi/v1/enterprise/detail', 'common', args);
			},
		},
	},
	'download': {
		"enterprise": {
			"whole": function (args) {
				return getApiUrl('/enterprise/index', 'download', args);
			},
			"finance": function (args) {
				return getApiUrl('/enterprise/word', 'download', args);
			}
		},
	},
	"park": {
		"localInvestEnterprise": {
			"detail": function (args) {
				return getApiUrl('/api/trend-api/v1/enterprise/detail', 'park', args);
			},
		},
		"localInvest": {
			"province": function (args) {
				return getApiUrl('/api/trend-api/v1/localInvest/province', 'park', args);
			},
			"city": function (args) {
				return getApiUrl('/api/trend-api/v1/localInvest/city', 'park', args);
			},
		},
		"building": {
			"areaList": function (args) {
				return getApiUrl('/api/park/v1/building/areaList', 'park', args);
			},
			"list": function (args) {
				return getApiUrl('/api/park/v1/building/list', 'park', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/park/v1/building/detail', 'park', args);
			},
			"enterpriselist": function (args) {
				return getApiUrl('/api/park/v1/building/enterpriselist', 'park', args);
			}
		},
		"enterprise": {
			"list": function (args) {
				return getApiUrl('/api/park/v1/enterprise/list', 'park', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/park/v1/enterprise/detail', 'park', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/park/v1/enterprise/detail2', 'park', args);
			},
		},

		"news": {
			"list": function (args) {
				return getApiUrl('/api/park/v1/news/list', 'park', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/park/v1/news/detail', 'park', args);
			},
			"industry": function (args) {
				return getApiUrl('/api/park/v1/news/industry', 'park', args);
			},
			"category": function (args) {
				return getApiUrl('/api/park/v1/news/category', 'park', args);
			},
		},
	},
	"tag": {
		"notionExtend": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/notionExtend/list', 'tag', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/tag/v1/notionExtend/detail', 'tag', args);
			}
		},
		"article": {
			"get": function (args) {
				return getApiUrl('/cmsapi/v1/article/get', 'tag', args);
			}
		},
		"apicode": {
			"get": function (args) {
				return getApiUrl('/api/tag/v1/apicode/get', 'tag', args);
			}
		},
		"notion": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/notion/list', 'tag', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/tag/v1/notion/detail', 'tag', args);
			}
		},
		"category": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/tag/category', 'tag', args);
			}
		},
		"tag": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/tag/list', 'tag', args);
			}
		},
	},
	"user": {
		"user": {
			"login": function (args) {
				return getApiUrl('/api/user/v1/user/login', 'user', args);
			}
		}
	},
	'investapi': {
		"area": {
			"province": function (args) {
				return getApiUrl('/api/invest/v1/area/province', 'cyl', args);
			}
		},
		"investdynamic": {
			"list": function (args) {
				return getApiUrl('/api/invest/v1/invest/list', 'cyl', args);
			},
			"enterpriseindvest": function (args) {
				return getApiUrl('/api/invest/v1/invest/enterpriseindvest', 'cyl', args);
			}
		},
		"invest": {
			"list": function (args) {
				return getApiUrl('/api/invest/v1/invest/list', 'cyl', args);
			},
			"enterpriseindvest": function (args) {
				return getApiUrl('/api/invest/v1/invest/enterpriseindvest', 'cyl', args);
			}
		},
		"finance": {
			"list": function (args) {
				return getApiUrl('/api/invest/v1/finance/list', 'cyl', args);
			},
		},
		"parameter": {
			"list": function (args) {
				return getApiUrl('/api/invest/v1/parameter/list', 'cyl', args);
			},
		}
	},
	'enterpriseapi': {
		"land": {
			"list": function (args) {
				return getApiUrl('/api/enterprise/v1/land/list', 'cyl', args);
			},
			"url": function (args) {
				return getApiUrl('/api/enterprise/v1/land/url', 'cyl', args);
			},
			"enterpriseinvest": function (args) {
				return getApiUrl('/api/enterprise/v1/land/enterpriseInvest', 'cyl', args);
			},
		},
		"parameter": {
			"landtype": function (args) {
				return getApiUrl('/api/enterprise/v1/parameter/landType', 'cyl', args);
			},
			"landarea": function (args) {
				return getApiUrl('/api/enterprise/v1/parameter/landArea', 'cyl', args);
			},
			"landindustry": function (args) {
				return getApiUrl('/api/enterprise/v1/parameter/landIndustry', 'cyl', args);
			},
		}
	},
	'rpt': {
			'parameter': {
				"class": function(args) {
					return getApiUrl('/api/report/v1/parameter/class', 'report', args);
				},
			},
			'report': {
				"list": function(args) {
					return getApiUrl('/api/report/v1/report/list', 'report', args);
				},
				"detail": function(args) {
					return getApiUrl('/api/report/v1/report/detail', 'report', args);
				},
				"page": function(args) {
					return getApiUrl('/api/report/v1/report/page', 'report', args);
				},
				"decode": function(args) {
					return getApiUrl('/api​/report​/v1​/report​/decode', 'report', args);
				},
			},
			'collect': {
				"add": function(args) {
					return getApiUrl('/api/report/v1/collect/add', 'report', args);
				},
				"remove": function(args) {
					return getApiUrl('/api/report/v1/collect/remove', 'report', args);
				},
				"list": function(args) {
					return getApiUrl('/api/report/v1/collect/list', 'report', args);
				},
			},
			"user": {
				"login": function(args) {
					return getApiUrl('/api/rpt/v1/user/login', 'report', args);
				},
			},
		},
	"cyl": {
		"assessment": {
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/assessment/Enterprise', 'cyl', args);
			},
			"history": function (args) {
				return getApiUrl('/api/cyl/v1/assessment/History', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/assessment/Detail', 'cyl', args);
			},
			"rename": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Rename', 'cyl', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Delete', 'cyl', args);
			},
		},
		"deepseek": {
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Enterprise', 'cyl', args);
			},
			"market": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Market', 'cyl', args);
			},
			"history": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/History', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Detail', 'cyl', args);
			},
			"rename": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Rename', 'cyl', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Delete', 'cyl', args);
			},
		},
		"allIndustryData": {
			"priceChange": function (args) {
				return getApiUrl('/api/cyl/v1/allIndustryData/priceChange', 'cyl', args);
			},
			"operate": function (args) {
				return getApiUrl('/api/cyl/v1/allIndustryData/operate', 'cyl', args);
			},
			 
		},
		"report": {
			"industryList": function (args) {
				return getApiUrl('/api/cyl/v1/report/industryList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/report/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/report/detail', 'cyl', args);
			},
			"futureIndustry": function (args) {
				return getApiUrl('/api/cyl/v1/report/futureIndustry', 'cyl', args);
			},
		},
		
		"statsData": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/statsData/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/statsData/detail', 'cyl', args);
			},
		},
		"market": {
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/market/detail2', 'cyl', args);
			},
		},
		"industryData": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/industryData/list', 'cyl', args);
			},
			"list2": function (args) {
				return getApiUrl('/api/cyl/v1/industryData/list2', 'cyl', args);
			},
			"areaList": function (args) {
				return getApiUrl('/api/cyl/v1/industryData/areaList', 'cyl', args);
			},
		},
		"userMessage": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/userMessage/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/userMessage/detail', 'cyl', args);
			},
			"latest": function (args) {
				return getApiUrl('/api/cyl/v1/userMessage/latest', 'cyl', args);
			},

		},
		"map": {
			"entlistbycity": function (args) {
				return getApiUrl('/api/cyl/v1/map/entlistbycity', 'cyl', args);
			},
			"mapdetail": function (args) {
				return getApiUrl('/api/cyl/v1/map/mapdetail', 'cyl', args);
			},
			"mapsimpledetail": function (args) {
				return getApiUrl('/api/cyl/v1/map/mapsimpledetail', 'cyl', args);
			},
			"mapcity": function (args) {
				return getApiUrl('/api/cyl/v1/map/mapcity', 'cyl', args);
			},
			"collect": function (args) {
				return getApiUrl('/api/cyl/v1/map/collect', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/map/EnterpriseList', 'cyl', args);
			},
		},
		'enterprisenews': {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterprisenews/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterprisenews/detail', 'cyl', args);
			},
		},
		'dynamicNotify': {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/dynamicNotify/list', 'cyl', args);
			},
			"read": function (args) {
				return getApiUrl('/api/cyl/v1/dynamicNotify/read', 'cyl', args);
			},

		},
		'association': {
			"city": function (args) {
				return getApiUrl('/api/cyl/v1/association/city', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/association/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/association/detail', 'cyl', args);
			},
			"enterpriselist": function (args) {
				return getApiUrl('/api/cyl/v1/association/enterpriselist', 'cyl', args);
			},
		},
		"competitive": {
			"comprehensive": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/comprehensive', 'cyl', args);
			},
			"scienceTech": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/scienceTech', 'cyl', args);
			},
			"industry": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/industry', 'cyl', args);
			},
			"localInvest": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/localInvest', 'cyl', args);
			},
			"financing": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/financing', 'cyl', args);
			},
			"externalInvest": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/externalInvest', 'cyl', args);
			},
		},
		'commerce': {
			"city": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/city', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/detail', 'cyl', args);
			},
			"enterpriselist": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/enterpriselist', 'cyl', args);
			},
		},
		'forcapenterprise': {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/forcapenterprise/list', 'cyl', args);
			},
			"export": function (args) {
				return getApiUrl('/api/cyl/v1/forcapenterprise/export', 'cyl', args);
			},

		},
		'foreignenterprise': {
			"paramList": function (args) {
				return getApiUrl('/api/cyl/v1/foreignenterprise/paramList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/foreignenterprise/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/foreignenterprise/detail', 'cyl', args);
			},

		},
		'userenterprise': {
			"add": function (args) {
				return getApiUrl('/api/cyl/v1/userenterprise/add', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/userenterprise/list', 'cyl', args);
			},
			"remove": function (args) {
				return getApiUrl('/api/cyl/v1/userenterprise/remove', 'cyl', args);
			},
		},
		"search": {
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/search/enterprise', 'cyl', args);
			},
		},
		"enterprise": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/detail', 'cyl', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/detail2', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/list', 'cyl', args);
			},
			"unlock": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/unlock', 'cyl', args);
			},
			"export": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/export', 'cyl', args);
			},
			"comparison": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/comparison', 'cyl', args);
			},
		},
		"enterpriseComparison": {
			"entInfo": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/entInfo', 'cyl', args);
			},
			"save": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/save', 'cyl', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/delete', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/detail', 'cyl', args);
			},
			"addEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/addEnterprise', 'cyl', args);
			},
			"deleteEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/deleteEnterprise', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/enterpriseList', 'cyl', args);
			},
		},
		"enterpriseCityRelation": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseCityRelation/list', 'cyl', args);
			},
		},
		"enterpriseEdition": {
			"macrobg": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/macroBg', 'cyl', args);
			},
			"industryenv": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/industryEnv', 'cyl', args);
			},
			"strategy": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/strategy', 'cyl', args);
			},
			"investdynamic": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/investDynamic', 'cyl', args);
			}
		},
		"ocnreport": {
			"category": function (args) {
				return getApiUrl('/api/cyl/v1/ocnReport/category', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/ocnReport/reportList', 'cyl', args);
			},
		},
		"enterpriseRelation": {
			"addEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/addEnterprise', 'cyl', args);
			},
			"deleteEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/deleteEnterprise', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/enterpriseList', 'cyl', args);
			},
			"deleteResult": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/deleteResult', 'cyl', args);
			},
			"calculate": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/calculate', 'cyl', args);
			},
			"save": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/save', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/detail', 'cyl', args);
			},
			"search": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/search', 'cyl', args);
			},
		},
		"localchain": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/detail', 'cyl', args);
			},
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/getNotion', 'cyl', args);
			},
			"set": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/setNotion', 'cyl', args);
			},
		},
		"collect": {
			"add": function (args) {
				return getApiUrl('/api/cyl/v1/collect/add', 'cyl', args);
			},
			"remove": function (args) {
				return getApiUrl('/api/cyl/v1/collect/remove', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/collect/list', 'cyl', args);
			},
			"export": function (args) {
				return getApiUrl('/api/cyl/v1/collect/export', 'cyl', args);
			},
			"map": function (args) {
				return getApiUrl('/api/cyl/v1/collect/map', 'cyl', args);
			},
			"enterpriseRelated": function (args) {
				return getApiUrl('/api/cyl/v1/collect/enterpriseRelated', 'cyl', args);
			},
			"enterpriseRelatedLevel2": function (args) {
				return getApiUrl('/api/cyl/v1/collect/enterpriseRelatedLevel2', 'cyl', args);
			},
			"addshortList": function (args) {
				return getApiUrl('/api/cyl/v1/collect/addShortList', 'cyl', args);
			},
			"removeshortList": function (args) {
				return getApiUrl('/api/cyl/v1/collect/removeShortList', 'cyl', args);
			},
		},
		"zttopic": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/zt/detail', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/zt/list', 'cyl', args);
			},
		},
		"land": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/land/list', 'cyl', args);
			},
		},
		"govementchart": {
			"economy": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/economy', 'cyl', args);
			},
			"industryland": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/industryLand', 'cyl', args);
			},
			"enterprisenum": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/enterpriseNum', 'cyl', args);
			},
			"investenv": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/investEnv', 'cyl', args);
			},
			"competitive": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/competitive', 'cyl', args);
			},
			"investment": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/investment', 'cyl', args);
			},
			"macrodata": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/macrodata', 'cyl', args);
			},
			"enterprisecount": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/enterpriseCount', 'cyl', args);
			},
			"mapserch": function (args) {
				return getApiUrl('/static/map/dist/#/', 'cyl', args);
			},
			"busiInvestAtals": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/busiInvestAtals', 'cyl', args);
			},
			"investProject": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/investProject', 'cyl', args);
			},
		},
		"govsaaschart": {
			"macrodata": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/macrodata', 'cyl', args);
			},
			"competitive": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/competitive', 'cyl', args);
			},
			"investment": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/investment', 'cyl', args);
			},
			"investenv": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/investEnv', 'cyl', args);
			},
			"investProject": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/investProject', 'cyl', args);
			},
			"industryland": function (args) {
				return getApiUrl('	/api/cyl/v1/govSaasChart/industryLand', 'cyl', args);
			},
			"enterprisecount": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/enterpriseCount', 'cyl', args);
			},
			"industryDevelop": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/industryDevelop', 'cyl', args);
			},
			"busiInvestAtals": function (args) {
				return getApiUrl('	/api/cyl/v1/govSaasChart/busiInvestAtals', 'cyl', args);
			},
			"chainurl": function (args) {
				return getApiUrl('/static/graph/chart.html', 'cyl', args);
			},
			"qxEcoDevelop": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/qxEcoDevelop', 'cyl', args);
			},
		},
		"specialTown": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/specialTown/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/specialTown/detail', 'cyl', args);
			},
			"notionList": function (args) {
				return getApiUrl('/api/cyl/v1/specialTown/notionList', 'cyl', args);
			},
		},
		"projectnews": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/projectNews/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/projectNews/detail', 'cyl', args);
			},
			"paramList": function (args) {
				return getApiUrl('/api/cyl/v1/projectNews/paramList', 'cyl', args);
			},
		},
		"park": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/park/detail', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/park/list', 'cyl', args);
			}
		},
		"news": {
			"datelist": function (args) {
				return getApiUrl('/api/cyl/v1/news/datelist', 'cyl', args);
			},
			"paramlist": function (args) {
				return getApiUrl('/api/cyl/v1/news/paramList', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/news/detail', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/news/list', 'cyl', args);
			}
		},
		"academy": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/academy/detail', 'cyl', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/academy/detail2', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/academy/list', 'cyl', args);
			}
		},
		"investorg": {
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/investorg/detail', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/investorg/enterpriseList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/investorg/list', 'cyl', args);
			}
		},
		"area": {
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/area/province', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/static/data/city_api.js', 'cyl', args);
			},
		},

		"chart": {
			"index": function (args) {
				return getApiUrl('/api/cyl/v1/chart/index', 'cyl', args);
			},
			"bigen": function (args) {
				return getApiUrl('/api/cyl/v1/chart/bigEnterprise', 'cyl', args);
			},
			"smen": function (args) {
				return getApiUrl('/api/cyl/v1/chart/smallEnterprise', 'cyl', args);
			},
			"investorg": function (args) {
				return getApiUrl('/api/cyl/v1/chart/investOrg', 'cyl', args);
			},
		},
		"parameter": {
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/industry', 'cyl', args);
			},
			"chain": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/chain', 'cyl', args);
			},
			"demandsupply": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/demandsupply', 'cyl', args);
			},
			"stockindustry": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/stockIndustry', 'cyl', args);
			},
		},
		"techdemand": {
			"post": function (args) {
				return getApiUrl('/api/cyl/v1/techdemand/post', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/techdemand/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/techdemand/detail', 'cyl', args);
			},
		},
		"techsupply": {
			"post": function (args) {
				return getApiUrl('/api/cyl/v1/techsupply/post', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/techsupply/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/techsupply/detail', 'cyl', args);
			},
		},
		"chain": {
			"download": function (args) {
				return getApiUrl('/api/cyl/v1/chain/download', 'cyl', args);
			},
			"nodelist": function (args) {
				return getApiUrl('/api/cyl/v1/chain/nodelist', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/chain/list', 'cyl', args);
			},
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/chain/detail', 'cyl', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/chain/detail2', 'cyl', args);
			},
			"index": function (args) {
				return getApiUrl('/api/cyl/v1/chain/index', 'cyl', args);
			},
		},
		"notion": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/notion/list', 'cyl', args);
			},
			"chainenterprise": function (args) {
				return getApiUrl('/api/cyl/v1/notion/enterprise', 'cyl', args);
			},
			"chainenterprisedetail": function (args) {
				return getApiUrl('/api/cyl/v1/notion/enterpriseList', 'cyl', args);
			},
			"notionEnterprseNum": function (args) {
				return getApiUrl('/api/cyl/v1/notion/enterpriseNum', 'cyl', args);
			},
		},
		"usercenter": {
			"index": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/index', 'cyl', args);
			},
			"updatenotion": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/updateNotion', 'cyl', args);
			},
			"updatepassword": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/updatePassword', 'cyl', args);
			},
			"baseinfo": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/baseInfo', 'cyl', args);
			},
			"updatebaseinfor": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/updateBaseinfo', 'cyl', args);
			},
			"investNotion": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/investNotion', 'cyl', args);
			},
			
		},
		'GovProvinceChart': {
            "Invest": function (args) {
                return getApiUrl('/api/cyl/v1/govprovincechart/Invest', 'cyl', args);
            },
            "Land": function (args) {
                return getApiUrl('/api/cyl/v1/govprovincechart/Land', 'cyl', args);
            },
            "EnterpriseData": function (args) {
                return getApiUrl('/api/cyl/v1/govprovincechart/EnterpriseData', 'cyl', args);
            },
			"GuandongInvest": function (args) {
                return getApiUrl('/api/cyl/v1/govprovincechart/GuandongInvest', 'cyl', args);
            },
			"GuandongLand": function (args) {
                return getApiUrl('/api/cyl/v1/govprovincechart/GuandongLand', 'cyl', args);
            },
			 
        },
		"home": {
			"all": function (args) {
				return getApiUrl('/api/cyl/v1/home/all', 'cyl', args);
			},
			"chain": function (args) {
				return getApiUrl('/api/cyl/v1/home/chain', 'cyl', args);
			},
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/home/enterprise', 'cyl', args);
			},
			"academy": function (args) {
				return getApiUrl('/api/cyl/v1/home/academy', 'cyl', args);
			},
			"investorg": function (args) {
				return getApiUrl('/api/cyl/v1/home/investorg', 'cyl', args);
			},
			"notice": function (args) {
				return getApiUrl('/api/cyl/v1/home/notice', 'cyl', args);
			},
		},
		"GovInvestAlg": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/govInvestAlg/detail', 'cyl', args);
			},
		},
		"OCNNews": {
			"keywords": function (args) {
				return getApiUrl('/api/cyl/v1/ocnNews/keywords', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/ocnNews/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/ocnNews/detail', 'cyl', args);
			},
		},
		"investclue": {
			"industry": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/industry', 'cyl',
					args); //以前的以商招商线索现已改为business，接口列表已隐藏但还能用
			},
			"area": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/area', 'cyl',
					args); //以前的重点区域招商线索现已改为keyarea，接口列表已隐藏但还能用
			},
			"finance": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/finance', 'cyl',
					args); //以前的资本招商线索现已改为capital，接口列表已隐藏但还能用
			},
			"ipo": function (args) {
				return getApiUrl('	/api/cyl/v1/investClue/ipo', 'cyl', args);
			},
			"business": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/business', 'cyl', args);
			},
			"keyarea": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/keyarea', 'cyl', args);
			},
			"hotspot": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/hotspotIndustry', 'cyl', args);
			},
			"capital": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/capital', 'cyl', args);
			},
			"rankList": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/rankList', 'cyl', args);
			},
			"rankDetail": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/rankDetail', 'cyl', args);
			},
			"EnterpriseInvestmentWindow": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/EnterpriseInvestmentWindow', 'cyl', args);
			},
			"IndustryInvestmentWindow": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/IndustryInvestmentWindow', 'cyl', args);
			},
			"relationEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/relationEnterprise', 'cyl', args);
			},
			"site": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/site', 'cyl', args);
			},
			"localWorthy": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/localWorthy', 'cyl', args);
			},
			"keyIndustry": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/keyIndustry', 'cyl', args);
			},
		},
		"export": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/export/enterprise', 'cyl', args);
			},
		},
		"foreignOrg": {
			"paramList": function (args) {
				return getApiUrl('/api/cyl/v1/foreignOrg/paramList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/foreignOrg/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/foreignOrg/detail', 'cyl', args);
			},
		},
		"appScene": {
			"paramList": function (args) {
				return getApiUrl('/api/cyl/v1/appScene/paramList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/appScene/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/appScene/detail', 'cyl', args);
			},
		},
		
	},
	"crm": {
		"user": {
			"login": function (args) {
				return getApiUrl('/api/crm/v1/user/login', 'crm', args);
			},
			"list": function (args) {
				return getApiUrl('/api/crm/v1/user/list', 'crm', args);
			},
			"transfer": function (args) {
				return getApiUrl('/api/crm/v1/user/transfer', 'crm', args);
			},
			"update": function (args) {
				return getApiUrl('/api/crm/v1/user/update', 'crm', args);
			},
			"add": function (args) {
				return getApiUrl('/api/crm/v1/user/add', 'crm', args);
			},
		},
		"workbench": {
			"workcount": function (args) {
				return getApiUrl('/api/crm/v1/workbench/workCount', 'crm', args);
			},
		},
		"department": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/department/list', 'crm', args);
			},
			"add": function (args) {
				return getApiUrl('/api/crm/v1/department/post', 'crm', args);
			},
		},
		"role": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/role/list', 'crm', args);
			},
		},
		"todo": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/todo/list', 'crm', args);
			},
			"post": function (args) {
				return getApiUrl('/api/crm/v1/todo/post', 'crm', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/crm/v1/todo/detail', 'crm', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/crm/v1/todo/delete', 'crm', args);
			},
		},
		"track": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/track/list', 'crm', args);
			},
			"post": function (args) {
				return getApiUrl('/api/crm/v1/track/post', 'crm', args);
			},
			"detail": function (args) {
				return getApiUrl('​/api​/crm​/v1​/track​/detail', 'crm', args);
			},
			"export": function (args) {
				return getApiUrl('/api/crm/v1/track/export', 'crm', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/crm/v1/track/delete', 'crm', args);
			},
		},
		"enterprise": {
			"addtoCRM": function (args) {
				return getApiUrl('/api/crm/v1/enterprise/addToCRM', 'crm', args);
			},
			"isExist": function (args) {
				return getApiUrl('	/api/crm/v1/enterprise/isExist', 'crm', args);
			},
		},
		"customer": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/customer/list', 'crm', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/crm/v1/customer/delete', 'crm', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/crm/v1/customer/detail', 'crm', args);
			},
			"post": function (args) {
				return getApiUrl('	/api/crm/v1/customer/post', 'crm', args);
			},
		},
		"analyse": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/analyse/list', 'crm', args);
			},
		},
		"contact": {
			"post": function (args) {
				return getApiUrl('/api/crm/v1/contact/post', 'crm', args);
			},
			"list": function (args) {
				return getApiUrl('/api/crm/v1/contact/list', 'crm', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/crm/v1/contact/detail', 'crm', args);
			},
		},
		"parameter": {
			"list": function (args) {
				return getApiUrl('/api/crm/v1/parameter/list', 'crm', args);
			},
		},

	}
};
function getParentUrl() {
	var url = null;
	if (parent !== window) {
		try {
			url = parent.location.href;
		} catch (e) {
			url = document.referrer;
		}
	}
	return url;
}


ajaxapi.getLoginUrl = getLoginUrl;
ajaxapi.getLogoutUrl = getLogoutUrl;
ajaxapi.getBigDataUrl = getBigDataUrl;
ajaxapi.getReportUrl = getReportUrl;
ajaxapi.getDownloadUrl = getDownloadUrl;
ajaxapi.getReportListUrl = getReportListUrl;
ajaxapi.getFreeReportUrl = getFreeReportUrl;


export default ajaxapi;
